import { useContext } from 'react';

import { setSelectedValue } from 'helpers/mappingColumns';

import { CAMEL_TYPES } from 'constants/menuManagement';

import ItemSelector from 'components/MenuManagement/MenuEdit/MenuMapping/ItemSelector';
import { MenuMappingContext } from 'components/MenuManagement/MenuEdit/MenuMapping/MenuMapping';
import { Item } from './types';

interface ModifierDetailProps {
  item: Item;
}

export default function ModifierDetail({ item }: ModifierDetailProps) {
  const { key, uuidExternalId, asAddition, replacesMain, ignore, asInstruction } = item;
  const itemType = CAMEL_TYPES.modifiers;

  const { allowSelection, checkedItems } = useContext(MenuMappingContext);

  return (
    <ItemSelector
      rowKey={key}
      selectedValue={uuidExternalId}
      // @ts-expect-error setSelectedValue not in ts
      setSelectedValue={setSelectedValue}
      selectorItemType={asAddition || replacesMain ? CAMEL_TYPES.items : itemType}
      itemType={itemType}
      disabled={
        !!asInstruction || !!ignore || (checkedItems?.control && checkedItems.control !== key)
      }
      allowSelection={allowSelection}
    />
  );
}
